<i18n>
{
  "en": {
    "edit": "Edit event",
    "delete": "Delete event",
    "start": "Start date:",
    "end": "End date:",
    "typeOfRepetition": "Frequence:",
    "daily": "Daily",
    "weekly": "Weekly",
    "monthly": "Monthly",
    "yearly": "Annual",
    "never": "Undefined repetitions",
    "on_date": "Until date:",
    "after": "Number of repetitions: "
  },
  "es": {
    "edit":  "Editar evento",
    "delete":  "Eliminar evento",
    "start": "Fecha inicial:",
    "end": "Fecha final:",
    "typeOfRepetition": "Frecuencia:",
    "daily": "Diario",
    "weekly": "Semanal",
    "monthly": "Mensual",
    "yearly": "Anual",
    "never": "Repeticiones indefinidas",
    "on_date": "Hasta la fecha:",
    "after": "Número de repeticiones:"
  }
}
</i18n>
<template>
  <dynameat-row
    :title="event.name"
    :description="event.description"
    :button-config-list="buttonConfigList"
    :collapse-items="!$vuetify.breakpoint.mdAndUp"
    @editEvent="onEditEvent"
    @deleteEvent="onDeleteEvent"
    :isClickable="false"
  >
    <template v-slot:aboveContent>
      <v-row align="center" class="chip-top">
        <v-chip color="primary" class="chip" small>{{ eventTypeMap[event.eventTypeGuid] }}</v-chip>
        <v-chip v-if="!event.recurrent"
          color="secondary" text-color="primary" class="chip" small>{{ $t('start') }} {{ event.startDate }}
        </v-chip>
        <v-chip v-if="!event.recurrent"
          color="secondary" text-color="primary" class="chip" small>{{ $t('end') }} {{ event.endDate }}
        </v-chip>
        <v-chip v-if="event.recurrent"
          color="secondary" text-color="primary" class="chip" small>
          {{ $t('typeOfRepetition') }} {{ eventRepetitionLabel(event.typeOfRepetition) }}
        </v-chip>
        <v-chip v-if="event.recurrent && event.endCondition === 'never'"
          color="secondary" text-color="primary" class="chip" small>
          {{ endConditionLabel(event.endCondition) }}
        </v-chip>
        <v-chip v-if="event.recurrent && event.endCondition === 'on_date'"
          color="secondary" text-color="primary" class="chip" small>
          {{ endConditionLabel(event.endCondition) }} {{ event.recurrenceEndDate }}
        </v-chip>
        <v-chip v-if="event.recurrent && event.endCondition === 'after'"
          color="secondary" text-color="primary" class="chip" small>
          {{ endConditionLabel(event.endCondition) }} {{ event.numberOfRepetitions }}
        </v-chip>
        <v-chip v-for="pointOfSale in eventPosList" :key="pointOfSale.guid" class="chip" x-small>{{ pointOfSale.name }}</v-chip>
      </v-row>
    </template>
  </dynameat-row>
</template>
<script>
import DynameatRow from '@dynameat/components/DynameatRow';
import Component from 'vue-class-component';
import { Components, MapGetters } from '@core/helpers/decorators';
import { Prop } from 'vue-property-decorator';
import { Event } from '@eventManager/models';
import Vue from 'vue';

@Component
@Components({ DynameatRow })
@MapGetters(['pointOfSaleList', 'eventTypeList'])
export default class EventRow extends Vue {
  @Prop({
    Object,
    validator(event) {
      return event instanceof Event;
    }
  }) event;

  get buttonConfigList() {
    return [
      {
        title: this.$t('edit'),
        icon: 'mdi-pencil',
        emitName: 'editEvent',
      },
      {
        title: this.$t('delete'),
        icon: 'mdi-delete',
        emitName: 'deleteEvent',
      }
    ];
  }

  get eventTypeMap() {
    const eventTypes = {};
    this.eventTypeList.forEach((eventType) => {
      eventTypes[eventType.guid] = eventType.name;
    });
    return eventTypes;
  }

  get eventPosList() {
    return this.pointOfSaleList.filter((item) => this.event.posGuidList.includes(item.guid));
  }

  eventRepetitionLabel(repetitionType) {
    const typeTranslations = {
      daily: this.$t('daily'),
      weekly: this.$t('weekly'),
      monthly: this.$t('monthly'),
      yearly: this.$t('yearly'),
    };
    return typeTranslations[repetitionType];
  }

  endConditionLabel(endCondition) {
    const conditionTranslations = {
      never: this.$t('never'),
      on_date: this.$t('on_date'),
      after: this.$t('after')
    };
    return conditionTranslations[endCondition];
  }

  onEditEvent() {
    this.$emit('edit');
  }

  onDeleteEvent() {
    this.$emit('delete');
  }
}
</script>
<style scoped lang="scss">
.chip-top {
  margin-top: 0;
  margin-left: 0;
}

.chip {
  margin-top: 5px;
  margin-right: 5px;
}
</style>
